// Listing launch kit: plain helpers the page and its tests share.

export const STATE_LABEL = {
  done: "Done",
  todo: "To do",
  booked: "Booked",
  waiting: "Waiting",
  skip: "Not needed",
  unknown: "Couldn't check",
};

export function stateLabel(state) {
  return STATE_LABEL[state] || "";
}

// The step the orange button acts on gets no second button of its own.
export function secondaryAction(step, next) {
  if (!step || !step.action) return null;
  if (next && next.step === step.key) return null;
  return step.action;
}

export function progressLine(kit) {
  if (!kit || !kit.progress) return "";
  const { done, total } = kit.progress;
  if (!kit.next && done >= total) return "Everything's ready.";
  return `${done} of ${total} ready`;
}

export function subtitle(kit) {
  const l = (kit && kit.listing) || {};
  return [l.address, l.mls_number].filter(Boolean).join(" · ");
}

// Filename from a Content-Disposition header, else the fallback.
export function fileName(disposition, fallback) {
  const m = String(disposition || "").match(/filename="?([^";]+)"?/i);
  return (m && m[1].trim()) || fallback || "download";
}

// A material's download URL with its option (e.g. ?address=1 for the social pack's address line) when switched on.
export function materialUrl(m, on) {
  if (!m) return "";
  if (!m.option || !on) return m.href;
  return `${m.href}${m.href.includes("?") ? "&" : "?"}${m.option.key}=1`;
}
